import { useQuery } from "@tanstack/react-query";
import { Users } from "lucide-react";
import { Card } from "@hp/ui";
import { fetchCilTopReviewers } from "../api/cil";

/** Tile-sized card for the home-page row: who did the most review work. Shown when Settings > Dashboard home > Show Top reviewers is ticked. */
export function TopReviewersCard() {
  const query = useQuery({ queryKey: ["cil", "top-reviewers"], queryFn: fetchCilTopReviewers, refetchInterval: 30_000 });
  const rows = (query.data ?? []).slice(0, 3);
  return (
    <Card className="rounded-lg p-0">
      <div className="flex items-start justify-between gap-3 px-4 py-3 sm:gap-4 sm:px-5 sm:py-4">
        <div className="min-w-0 flex-1">
          <div className="text-xs font-medium uppercase tracking-wide text-zinc-500">Top reviewers</div>
          {query.isError ? <div className="mt-1.5 text-xs text-red-700">Could not load reviewers.</div> : null}
          {query.isSuccess && rows.length === 0 ? <div className="mt-1.5 text-xs text-zinc-500">No one has reviewed anything yet.</div> : null}
          {!query.isSuccess && !query.isError ? <div className="mt-1.5 font-mono text-xl font-semibold text-zinc-900 sm:text-2xl">…</div> : null}
          <ol className="mt-1.5 space-y-1.5">
            {rows.map((row, index) => (
              <li key={row.email} title={`${row.name}: ${row.reviewed} reviewed, ${row.confirmed} confirmed, ${row.closed} closed, ${row.rejected} rejected`}>
                <div className="flex items-baseline justify-between gap-2">
                  <span className="truncate text-sm font-medium text-zinc-900">
                    <span className="mr-1.5 font-mono text-xs text-zinc-400">{index + 1}</span>
                    {row.name}
                  </span>
                  <span className="font-mono text-sm font-semibold tabular-nums text-zinc-900">{row.total}</span>
                </div>
                <div className="pl-4 text-[0.6875rem] leading-snug text-zinc-500">
                  {row.reviewed} reviewed · {row.confirmed} confirmed · {row.closed} closed · {row.rejected} rejected
                </div>
              </li>
            ))}
          </ol>
        </div>
        <div className="flex h-10 w-10 flex-none items-center justify-center rounded-lg bg-zinc-400/15 text-zinc-600">
          <Users className="h-5 w-5" aria-hidden />
        </div>
      </div>
    </Card>
  );
}
